import React from "react";

export function Kpi({ label, value, sub, testid, accent, disclosure }) {
  return (
    <div
      className="bg-white border border-gray-200 p-5 flex flex-col gap-2"
      data-testid={testid}
    >
      <div className="flex items-start justify-between gap-2">
        <span className="text-[11px] font-semibold uppercase tracking-wider text-gray-500">
          {label}
        </span>
        {disclosure ? <div className="flex-shrink-0">{disclosure}</div> : null}
      </div>
      <span
        className={"text-3xl font-bold font-mono " + (accent || "text-gray-900")}
      >
        {value}
      </span>
      {sub ? (
        <span className="text-xs text-gray-500 leading-snug">{sub}</span>
      ) : null}
    </div>
  );
}

export default Kpi;
